export var valuesPALMSUserTrainingStatusEnum = ["Completed", "OnTrack", "Overdue", "ThisMonth", "NextMonth", "Inactive"];
/*

*/ 
//# sourceMappingURL=PALMSUserTrainingStatusEnum.js.map